<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin tw-mb-6 tw-text-center sm:tw-text-left">Recharge Plan: {{ planName }}</h3>
      <div class="tw-font-light sm:tw-flex tw-justify-between tw-whitespace-nowrap tw-items-center">
        <div class="tw-text-center sm:tw-text-left">How many credits would you like to buy?</div>
        <credits-picker class=" tw-justify-center sm:tw-justify-left" v-model="rechargeCount" :allow-negative="false" />
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-8">
        <base-button @click="rechargeCredits" :disabled="rechargeCount <= 0" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">
          Recharge {{ rechargeCount }} {{ rechargeCount == 1 ? "credit" : "credits" }} for {{ chargePriceFormatted }}
        </base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import CreditsPicker from "@/views/user/components/CreditsPicker";

export default {
  components: {
    CreditsPicker,
  },
  props: {
    businessId: String,
    userId: String,
    userBusinessPlanId: String,
    creditUnitPriceInCents: Number,
    currency: String,
    planName: String,
  },
  data() {
    return {
      isLoading: false,
      rechargeCount: 1,
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    chargePriceFormatted() {
      return this.creditUnitPriceInCents
        ? new Intl.NumberFormat(this.locale, { style: "currency", currency: this.currency }).format((this.creditUnitPriceInCents * this.rechargeCount) / 100)
        : "";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async rechargeCredits() {
      try {
        this.isLoading = true;

        const response = await this.$axios.post(`/users/${this.userId}/plans/${this.userBusinessPlanId}/recharge`, {
          businessId: this.businessId,
          quantity: this.rechargeCount,
        });
        if (response.data.chargeStatus === "succeeded") {
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Plan Recharged", message: "You successfully recharged " + this.rechargeCount + " credits" });
          this.EventBus.$emit("member_update");
          this.$emit("member_update");
          this.errorMessage = null;
          this.hide();
        } else {
          this.errorMessage = "Charge " + response.data.chargeStatus + ": " + response.data.sellerMessage;
        }
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Error Recharging Plan",
          message: "We were not able to recharge your credits. There may have been a connection error. Please reload the page to try again.",
          error: error,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
